import { useEffect, FC, useState } from "react";
// echarts and china maps
import * as echarts from "echarts";
import { Select, Divider, Form } from "antd";
import { Card } from "./components/Card";
import { useSelector } from "react-redux";
import { Map } from "../json";
import {
  getProvinceLearnView,
  getProvinceLearnEchartData,
} from "@root/common/service";
import { RootState } from "@root/store";
import SubjectSelect from "@root/components/selectBox/subjectSelect";
const { Option } = Select;
type EChartsOption = echarts.EChartsOption;
const China: FC = () => {
  const [cardArray, setCardArray] = useState<any[]>([]);
  const { echartCityData = [] } = useSelector(
    (state: RootState) => state.directionaries
  );
  const { provinceCode = "110000" } = useSelector(
    (state: RootState) => state.userInfo
  );

  async function getCountryViewData(subject?: number | undefined) {
    let chartDom = document.getElementById("MAP")!;
    let myChart = echarts.init(chartDom);
    myChart.showLoading();

    const {
      data: {
        instituteDataInfo,
        userDataInfo = { userCount: 0 },
        learnRecordInfo,
        learnCourseInfo,
      },
    } = await getProvinceLearnView({ subjectId: subject });
    const {
      data: { globalViewMapDataList },
    } = await getProvinceLearnEchartData({ subjectId: subject });
    // 处理echartData数据
    let echartData = globalViewMapDataList.map((item: any, index: number) => {
      return {
        name: item.cityName,
        value: item.recipientHospitalCount,
      };
    });

    const {
      countyHospitalCount,
      supportHospitalCount,
      recipientHospitalCount,
    } = instituteDataInfo;
    const { userCount } = userDataInfo;
    const { learnUserCount, learnRatio, watchTime, averageWatchTime } =
      learnRecordInfo;
    const {
      totalCourseCount,
      supportHospitalCourseCount,
      recipientHospitalCourseCount,
    } = learnCourseInfo;
    let initCardArray = [
      {
        name: "机构数量",
        subtitles: [
          {
            name: "机构总数",
            number: countyHospitalCount,
          },
          {
            name: "支援医院数量",
            number: supportHospitalCount,
          },
          {
            name: "受援医院数量",
            number: recipientHospitalCount,
          },
        ],
      },
      {
        name: "人数统计",
        subtitles: [
          {
            name: "注册总人数",
            number: userCount,
          },
          {
            name: "学习人数",
            number: learnUserCount,
          },
        ],
      },
      {
        name: "课程统计",
        subtitles: [
          {
            name: "课程总数",
            number: totalCourseCount,
          },
          {
            name: "支援医院课程数",
            number: supportHospitalCourseCount,
          },
          {
            name: "受援医院课程数",
            number: recipientHospitalCourseCount,
          },
        ],
      },
      {
        name: "学习统计",
        subtitles: [
          {
            name: "培训率",
            number: `${learnRatio}%`,
          },
          {
            name: "学习时长(小时)",
            number: watchTime,
          },
          {
            name: "平均学习时长(小时)",
            number: averageWatchTime,
          },
        ],
      },
    ];
    setCardArray([...initCardArray]);
    let option: EChartsOption;
    const index = echartCityData.findIndex(
      (item) => item.code === provinceCode
    );
    const name = echartCityData[index].map;
    echarts.registerMap("China", Map[name as keyof typeof Map] as any);

    let arr = echartData.map((item: any) => {
      return item.value;
    });
    myChart.hideLoading();
    myChart.setOption(
      (option = {
        title: {
          text: "各市数据分布",
          subtext: "",
          left: "left",
        },
        tooltip: {
          trigger: "item",
          formatter: function (params: any) {
            const { name } = params;
            const {
              supportHospitalCount,
              recipientHospitalCount,
              userCount,
              supportHospitalCourseCount,
              recipientHospitalCourseCount,
              learnRatio,
            } = globalViewMapDataList.find(
              (item: any) => item.cityName === name
            );
            let str: string = "";
            str += `支援医院数量: ${supportHospitalCount} <br/>`;
            str += `受援医院数量: ${recipientHospitalCount} <br/>`;
            str += `注册人数: ${userCount} <br/>`;
            str += `支援医院课程数量: ${supportHospitalCourseCount} <br/>`;
            str += `受援医院课程数量: ${recipientHospitalCourseCount} <br/>`;
            str += `培训率: ${learnRatio}% <br/>`;
            return str;
          },
        },
        toolbox: {
          show: true,
          orient: "vertical",
          left: "right",
          top: "center",
          feature: {},
        },
        visualMap: {
          type: "continuous",
          min: 0,
          max: Math.max(...arr),
          calculable: false,
          show: false,
          inRange: {
            color: ["#e0f3f8", "#abd9e9", "#74add1", "#4575b4", "#313695"],
          },
        },
        series: [
          {
            name: "各市数据分布",
            type: "map",
            map: "China",
            zoom: 1.1,
            label: {
              show: true,
            },
            data: echartData,
          },
        ],
      })
    );

    option && myChart.setOption(option);
  }
  useEffect(() => {
    getCountryViewData();
  }, []);

  const onSelectChangeHandle = (value: any) => {
    if (value === "all") {
      value = undefined;
    }

    getCountryViewData(value);
  };

  return (
    <div className="summarize">
      <div className="summarize-wrapper">
        <Form>
          <SubjectSelect
            label={false}
            showAll={true}
            styles={{ width: 160 }}
            onSelect={(value) => {
              onSelectChangeHandle(value);
            }}
          />
        </Form>
        <Divider />
        <div className="summarize-card-wrapper">
          {cardArray.map((item, index) => {
            return (
              <Card key={index} name={item.name} subtitle={item.subtitles} />
            );
          })}
        </div>
        <div id="MAP"></div>
      </div>
    </div>
  );
};

export default China;
